module.exports = __webpack_public_path__ + "img/13.541c5a0.svg";